import { useTranslation } from "@/hooks/useTranslation/useTranslation"

interface MasterDataListMetaProps {
  selectedCount: number
  totalCount: number
}

/** Selected-count caption shown under the search row while rows are checked. */
export function MasterDataListMeta({
  selectedCount,
  totalCount,
}: MasterDataListMetaProps) {
  const { translate } = useTranslation()
  return (
    <span>
      {translate("MC_MD_LIST_SELECTED_COUNT", {
        count: selectedCount,
        total: totalCount,
      })}
    </span>
  )
}
